import React, { useCallback } from 'react';
import MediaRenderer from './MediaRenderer';
import mockComponents from '../../../data/mockComponents.json';
import { agComponentsAPI } from '../../../services/api';

const AgComponents = ({
  apiData,
  pageSize = 20,
  gridCols = 1,
  className = '',
  onDragStart,
  renderCustomItem,
  endMessage,
  loadingComponent,
  errorComponent,
  onItemDoubleClick,
  dependencies = [],
  searchQuery,
}) => {
  // This function accepts `page` and `pageSize` for pagination
  const fetchComponentData = useCallback(
    async (page, pageSize) => {
      try {
        // Step 1: Prepare the parameters for the API call.
        const params = {
          page: 1,
          limit: pageSize,
          search: searchQuery,
        };

        // Step 2: Call the API with the pagination and search parameters.
        const response = await agComponentsAPI.getAll(params);

        // Step 3: Extract the data and pagination info from the API response.
        const components = response.data?.data?.previews || [];
        const currentPage = response.data?.page || 0;
        const totalPages = response.data?.pages || 0;

        // Step 4: Determine if there are more pages to load.
        const hasMore = currentPage < totalPages;

        // Step 5: Return the data and 'hasMore' flag in the format MediaRenderer expects.
        return {
          data: components,
          hasMore: hasMore,
        };
      } catch (error) {
        console.error('Error fetching AG Components:', error);
        // On error, return an empty state so the component doesn't crash.
        return { data: [], hasMore: false };
      }
    },
    [searchQuery] // Add pageSize to dependencies if it can change dynamically
  );

  const handleItemDoubleClick = (item) => {
    if (onItemDoubleClick && typeof onItemDoubleClick === 'function') {
      onItemDoubleClick(item);
    }
  };

  return (
    <MediaRenderer
      key={searchQuery}
      apiData={apiData}
      dataFetcher={!apiData ? fetchComponentData : undefined}
      pageSize={pageSize}
      gridCols={gridCols}
      className={className}
      itemType="component"
      onDragStart={onDragStart}
      renderCustomItem={renderCustomItem}
      endMessage={endMessage || 'No more components to load'}
      loadingComponent={loadingComponent}
      errorComponent={errorComponent}
      dependencies={[...dependencies, searchQuery]}
      showDuration={true}
      onItemDoubleClick={handleItemDoubleClick}
      showSize={false}
      showType={true}
      layout="masonry"
      targetRowHeight={130}
      justifiedGap={4}
      getAspectRatio={(item) => {
        if (item.width && item.height) return item.width / item.height;
        return 16 / 9;
      }}
    />
  );
};

export default AgComponents;
